module.exports = __webpack_public_path__ + "img/report.74cd64fe.svg";